import { Validators } from '@angular/forms';

export class SubmitModel {
    generalTerms = {
        value: true,
        validation: Validators.compose([
            Validators.requiredTrue
        ])
    };
}
